var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkeletonMenuDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu-dots 1",
    clipPath: "url(#clip0_2177_1144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 8.5C10 7.39543 9.10457 6.5 8 6.5C6.89543 6.5 6 7.39543 6 8.5C6 9.60457 6.89543 10.5 8 10.5C9.10457 10.5 10 9.60457 10 8.5Z",
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 14.5C10 13.3954 9.10457 12.5 8 12.5C6.89543 12.5 6 13.3954 6 14.5C6 15.6046 6.89543 16.5 8 16.5C9.10457 16.5 10 15.6046 10 14.5Z",
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10 2.5C10 1.39543 9.10457 0.5 8 0.5C6.89543 0.5 6 1.39543 6 2.5C6 3.60457 6.89543 4.5 8 4.5C9.10457 4.5 10 3.60457 10 2.5Z",
    fill: "#F8F9FA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2177_1144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 16.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkeletonMenuDot);
export default __webpack_public_path__ + "static/media/skeleton-menu-dot.23c610531697002670f0d42be77b447c.svg";
export { ForwardRef as ReactComponent };